import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class CommentIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 40 40"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<rect width="40" height="40" x="0" y="0"
					  style={{
						  fill: this.props.color,
						  fillOpacity: 0.5,
						  fillRule: "evenodd",
						  stroke: "#000000",
						  strokeWidth: 1,
						  strokeMiterlimit: 4,
						  strokeOpacity: 1,
						  strokeDasharray: "none"
					  }}/>
				<path
					d="m 20.677967,8.54499 c -7.342801,0 -13.295293,4.954293 -13.295293,11.065751 0,2.088793 0.3647173,3.484376 1.575539,5.150563 L 6.0267418,31.45501 13.560595,29.011117 c 2.221262,1.387962 4.125932,1.665377 7.117372,1.665377 7.3428,0 13.295291,-4.954295 13.295291,-11.065753 0,-6.111458 -5.952491,-11.065751 -13.295291,-11.065751 z"
					style={{
						fill: "#ffffff",
						fillOpacity: 1,
						stroke: "#000000",
						strokeWidth: 0.93031836,
						strokeMiterlimit: 4,
						strokeOpacity: 1,
						strokeDasharray: "none"
					}}/>
			</svg>
		);
	}
}